import React from 'react';

import { Avatar as NewAvatar } from '@/ui/Avatar/Avatar';

import { Props } from './types';

const sizeMap = {
  small: 'sm',
  medium: 'md'
} as const;

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Avatar: React.FC<Props> = ({ avatarUrl, name = 'User', size = 'medium', className = '' }) => (
  <NewAvatar src={avatarUrl} name={name} size={sizeMap[size]} className={className} />
);

export default Avatar;
